
export const aggregateInputs = {
  date: [
    {
      type: 'text',
      label: 'editor.dataset',
      name: 'dataset_name',
      width: '100%',
      default: '',
      placeholder: 'Dataset',
    },
    {
      type: 'select',
      label: 'editor.aggregate',
      name: 'aggregate',
      width: '100%',
      default: 'count',
      options: [
        { name: 'dashboard.manager.count', value: 'count', icon: 'calculate' },
        { name: 'Distinct', value: 'distinct', icon: 'filter_list' },
        { name: 'editor.enumerate', value: 'enumerate', icon: 'format_list_numbered' },
        { name: 'dashboard.manager.first', value: 'first', icon: 'first_page' },
        { name: 'dashboard.manager.last', value: 'last', icon: 'last_page' },
      ],
    },
  ],
  boolean: [
    {
      type: 'text',
      label: 'editor.dataset',
      name: 'dataset_name',
      width: '100%',
      default: '',
      placeholder: 'Dataset',
    },
    {
      type: 'select',
      label: 'editor.aggregate',
      name: 'aggregate',
      default: 'count',
      width: '100%',
      options: [
        { name: 'dashboard.manager.count', value: 'count', icon: 'calculate' },
        { name: 'Distinct', value: 'distinct', icon: 'filter_list' },
      ],
    },
  ],
  number: [
    {
      type: 'text',
      label: 'editor.dataset',
      name: 'dataset_name',
      width: '100%',
      default: '',
      placeholder: 'Dataset',
    },
    {
      type: 'select',
      label: 'editor.aggregate',
      name: 'aggregate',
      default: 'count',
      width: '100%',
      options: [
        { name: 'editor.sum', value: 'sum', icon: 'add' },
        { name: 'dashboard.manager.count', value: 'count', icon: 'calculate' },
        { name: 'Distinct', value: 'distinct', icon: 'filter_list' },
        { name: 'editor.enumerate', value: 'enumerate', icon: 'format_list_numbered' },
        { name: 'editor.mean', value: 'mean', icon: 'show_chart' },
        { name: 'units.min', value: 'min', icon: 'arrow_downward' },
        { name: 'units.max', value: 'max', icon: 'arrow_upward' },
        { name: 'dashboard.manager.first', value: 'first', icon: 'first_page' },
        { name: 'dashboard.manager.last', value: 'last', icon: 'last_page' },
        { name: 'Variance', value: 'variance', icon: 'bar_chart' },
        { name: 'editor.standardDeviation', value: 'standardDeviation', icon: 'insights' },
      ],
    },
  ],
  string: [
    {
      type: 'text',
      label: 'editor.dataset',
      name: 'dataset_name',
      width: '100%',
      default: '',
      placeholder: 'Dataset',
    },
    {
      type: 'select',
      label: 'editor.aggregate',
      name: 'aggregate',
      width: '100%',
      default: 'count',
      options: [
        { name: 'dashboard.manager.count', value: 'count', icon: 'calculate' },
        { name: 'Distinct', value: 'distinct', icon: 'filter_list' },
        { name: 'editor.enumerate', value: 'enumerate', icon: 'format_list_numbered' },
        { name: 'dashboard.manager.first', value: 'first', icon: 'first_page' },
        { name: 'dashboard.manager.last', value: 'last', icon: 'last_page' },
      ],
    },
  ],
  objectid: [
    {
      type: 'text',
      label: 'editor.dataset',
      name: 'dataset_name',
      width: '100%',
      default: '',
      placeholder: 'Dataset',
    },
    {
      type: 'select',
      label: 'editor.aggregate',
      name: 'aggregate',
      width: '100%',
      default: 'count',
      options: [
        { name: 'dashboard.manager.count', value: 'count', icon: 'calculate' },
        { name: 'Distinct', value: 'distinct', icon: 'filter_list' },
        { name: 'editor.enumerate', value: 'enumerate', icon: 'format_list_numbered' },
        { name: 'dashboard.manager.first', value: 'first', icon: 'first_page' },
        { name: 'dashboard.manager.last', value: 'last', icon: 'last_page' },
      ],
    },
  ],
};